import React from 'react'
import Header from '../../component/Header';
import Footer from '../../component/Footer';
import Brandlogos from '../../component/Brandlogos';

export default function Brandspage() {
    return (
        <div className="w-full">
            <Header />
                <div className="bg-white">
                    <Brandlogos />
                </div>
                <Footer />
        </div>
    )
}
